import { render, staticRenderFns } from "./Filesystem.vue?vue&type=template&id=4b3d235a&"
import script from "./Filesystem.vue?vue&type=script&lang=js&"
export * from "./Filesystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports